import React from "react"
import PropTypes from "prop-types"
import { Button, Link as ExternalLink } from "@material-ui/core"
import {Link as InternalLink} from 'gatsby';
import { makeStyles } from "@material-ui/core/styles"
import { linkReset } from "../../helpers/linkReset"

const internalStyle = makeStyles(theme => ({
    root: {
        marginRight: theme.spacing(2),
    },
    active: {
        border: "1px solid rgba(0, 0, 0, 0.23)",
        borderColor: "currentColor",
        padding: "5px 15px",
    },
}));

const InternalButton = ({ name, link }) => {
    const classes = internalStyle();

    return <Button
        color='inherit'
        className={classes.root}
        component={InternalLink}
        to={link}
        activeClassName={classes.active}
        partiallyActive
    >
        {name}
    </Button>
}

const externalStyle = makeStyles(theme => ({
    root: {
        ...linkReset,
        marginRight: theme.spacing(2),
    },
}));

const ExternalButton = ({name, link}) => {
    const classes = externalStyle();

    return <Button
        color={'inherit'}
        className={classes.root}
        component={ExternalLink}
        href={link}
    >
        {name}
    </Button>;
}

export const DesktopButton = (props) => {
    return props.external
        ? <ExternalButton {...props} />
        : <InternalButton {...props} />;
}

DesktopButton.propTypes = {
    name: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
    external: PropTypes.bool.isRequired,
}